/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_CustomerInputs */

const vi_order_customer = /** @type {(inputs: Order_CustomerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách hàng`)
};

/**

* @param {Order_CustomerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_customer = /** @type {((inputs?: Order_CustomerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_CustomerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_customer(inputs)
});